import * as React from 'react';
import Select, {
	SelectValue,
} from '../../../../../Components/Base/Select/Select';
import { useTermItemsQuery } from '../../../../../graphql/graphql';
import { FieldError } from 'react-hook-form';
import { useMemo } from 'react';
import Loading from '../../../../../Components/Loading';
import useTranslation from '../../../../../Hooks/useTranslation';
import { createFilter } from 'react-select';
import useSelectValueGuard from '../../../Hooks/useSelectValueGuard';

interface Props {
	onChange?: (value: SelectValue) => void;
	value?: SelectValue | string;
	error?: FieldError;
}

const FormOfCareSelect: React.FC<Props> = props => {
	const { value, onChange } = props;
	const { data, isLoading } = useTermItemsQuery({
		termType: 'sukl_forma_pece',
		take: 999,
	});
	const { t } = useTranslation();

	const options: SelectValue[] = useMemo(() => {
		const items: SelectValue[] = [];

		for (const termItem of data?.termItems?.data || []) {
			if (termItem && termItem.name) {
				items.push({
					value: termItem.id,
					label: termItem.name,
				});
			}
		}

		return items;
	}, [data]);

	useSelectValueGuard({ options, value, onChange });

	if (isLoading) {
		return <Loading />;
	}

	return (
		<Select
			options={options}
			{...props}
			onChange={onChange}
			placeholder={t('base.shared.pick')}
			value={value}
			filterOption={createFilter({
				stringify: option => `${option.label}`,
			})}
			isSearchable
		/>
	);
};

export default FormOfCareSelect;
